import { LogEventProps } from '../domain';
import { meetDataFromUrl } from '../../../utils/meetDataFromUrl';
import { get } from '../../SessionStorageState/services';
import { Meet } from '../../Meet/domain/types';
import * as Sentry from '@sentry/react';

const { logger } = Sentry;

function meetIdentifiersFromStorage() {
	const meet = get<Meet>('meet');
	if (!meet) {
		return {};
	}

	const patient = meet.participants?.find(({ type }) => type.toLowerCase() === 'patient');
	const professional = meet.participants?.find(({ type }) => type.toLowerCase() === 'professional');
	let role: string | undefined;
	if (meet.memberId) {
		role = meet.memberId === professional?.memberId ? 'professional' : 'patient';
	}

	return {
		videoconsultationId: meet.videoId,
		patientId: patient?.memberId,
		role,
	};
}

export function logEvent({ message, attachedData }: LogEventProps) {
	const meetParams = meetDataFromUrl(window.location.href);
	logger.trace(message, {
		...attachedData,
		...meetParams,
		...meetIdentifiersFromStorage(),
		path: window.location.pathname,
	});
}
